import { Element } from './element';

export class Page {
  public name: string;
  public caption: string;
  public margin_id: number;
  public size_id: number;
  public orientation_id: number;

  constructor(name: string, caption: string, margin_id: number, size_id: number, orientation_id: number) {
    this.name = name;
    this.caption = caption;
    this.margin_id = margin_id;
    this.size_id = size_id;
    this.orientation_id = orientation_id;
  }
}
